<!-- 
A yes/no confirmation dialog.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog md">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <slot/>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat @click="hide">{{ cancelCaption }}</v-btn>
        <v-btn :color="confirmColor" flat @click="$emit('confirm')">
          {{ confirmCaption }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    cancelCaption: {
      type: String,
      default: "No"
    },
    confirmCaption: {
      type: String,
      default: "Yes"
    },
    confirmColor: {
      type: String,
      default: "error"
    },
    title: {
      type: String,
      default: "Are you sure?"
    }
  },
  methods: {
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
